export default {
    strings: {
        pluginNameUrl: 'Link',
        // Label for the "Import" button.
        import: 'Import',
        // Placeholder text for the URL input.
        enterUrlToImport: 'Enter URL to import a file',
        // Error message shown if Companion could not load a URL.
        failedToFetch: 'Companion failed to fetch this URL, please make sure it’s correct',
        // Error message shown if the input does not look like a URL.
        enterCorrectUrl: 'Incorrect URL: Please make sure you are entering a direct link to a file',
    },
};
